var map = {
	"./app-icon.svg": 1714,
	"./caret-right-icon.svg": 1715,
	"./chrome-icon.webp": 1716,
	"./edge-icon.webp": 1717,
	"./firefox-icon.webp": 1718,
	"./opera-icon.webp": 1719,
	"./safari-icon.webp": 1720,
	"./unknown-icon.webp": 1721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1713;